import { useEffect, useState } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

function useMenuOpenKeys(topMenu) {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();

  const pathArray = pathname.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  useEffect(() => {
    if (!topMenu) {
      setOpenKeys([mainPathSplit[1]]);
    } else {
      setOpenKeys([]);
    }
  }, [pathname, topMenu]);

  return openKeys;
}

export default useMenuOpenKeys;
